import { useState, type JSX } from 'react';

import styles from './styles.module.css';

const FAQS: Array<{ q: string; a: string }> = [
  {
    q: 'How does care coordination work?',
    a: 'If your patient enrolls, NourishedRx reaches out to you with next steps for care coordination. From there, lab sharing, outcome updates, and escalation alerts all flow back to you throughout the year — so you stay informed without any extra administrative work.',
  },
  {
    q: 'What does the referral form ask for?',
    a: "Your patient's name, date of birth, Medicare ID, qualifying condition, and a few clinical readings relevant to that condition (for example, blood pressure for hypertension or A1c for diabetes). Your own details verify automatically against NPPES. It takes about 5 minutes, and your information is saved for next time.",
  },
  {
    q: 'What does my patient actually get?',
    a: "A 12-month, fully digital program: the Betty app with daily check-ins, personalized nutrition guidance and recipes, educational content, optional clinically-appropriate prepared meals, and live group sessions with a Registered Dietitian. It's a complete digital nutrition experience.",
  },
  {
    q: "What's my ongoing administrative burden?",
    a: "Light. After the 5-minute referral, NourishedRx handles enrollment, engagement, and care coordination, and tracks the quarterly labs and outcome data to support compliance. You'll get automatic milestone and lab updates and a year-end outcomes summary. You'll still submit what's needed on your end for reimbursement — and we make that part straightforward.",
  },
  {
    q: 'Is there any cost to my patient?',
    a: 'No. For eligible Medicare beneficiaries, NourishedRx is a covered ACCESS benefit — no copays, no fees.',
  },
  {
    q: 'How is eligibility and CMS compliance handled?',
    a: "Eligibility is confirmed with CMS before enrollment. HIPAA consent is captured before any health information is collected, and NourishedRx automatically links quarterly labs to the member's CMS record and compiles the outcome data across all four quarterly windows to support reporting.",
  },
  {
    q: 'A patient sent me this link themselves — is that okay?',
    a: "Yes. Beneficiaries can't self-enroll, so we encourage them to ask their provider to refer them. When a referral arrives from a member-shared link it's still you, the provider, who submits it — we simply note the source for reporting.",
  },
];

export function ProviderFaq(): JSX.Element {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className={styles.secPad} id="faqs">
      <div className={styles.wrapNarrow}>
        <h2 className={`${styles.center} ${styles.sectionH2}`} style={{ marginTop: 0 }}>
          Provider FAQs
        </h2>
        <div className={styles.faqList}>
          {FAQS.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div key={idx} className={styles.faqItem}>
                <button
                  className={styles.faqQ}
                  aria-expanded={isOpen}
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                >
                  <span className={`${styles.faqPm}${isOpen ? ` ${styles.faqPmOpen}` : ''}`}>
                    +
                  </span>
                  {faq.q}
                </button>
                <div className={styles.faqBody} style={{ maxHeight: isOpen ? '600px' : '0' }}>
                  <div>{faq.a}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
